import { Button } from '@mui/material';
import React from 'react';
import NotificacaoStore from '../store/NotificacaoStore';
import RouterStore from '../store/RouterStore';
import EscaninhoService from '../services/EscaninhoService';

interface IPropsNotificacaoMinutaDevolvida {
    count: number;
}

export default class NotificacaoMinutaDevolvida extends React.PureComponent<IPropsNotificacaoMinutaDevolvida> {

    irParaEscaninhoDevolucao = () => {
        if(RouterStore.isEscaninhoFiltrado){
            EscaninhoService.ajustarFiltros();
        }
        RouterStore.push('/escaninho/filtrado?situacaoMinuta=70');
        NotificacaoStore.fechar();
    }
    render() {
        return (
            <div>
                Seu gabinete possui {this.props.count} minuta{this.props.count > 1 ? 's' : ''} devolvida{this.props.count > 1 ? 's' : ''} para correção.
                <Button variant='contained' onClick={this.irParaEscaninhoDevolucao}>
                    Me mostre
                </Button>
            </div>
        );
    }
}
